import { faker } from '@faker-js/faker';
import { Factory, trait } from 'miragejs';

export default Factory.extend({
  assetTypeSelector() {
    return 'Video';
  },

  headline() {
    return faker.name.fullName();
  },

  imageUrlTemplate() {
    return 'https://image-template.de/{ratio}/{width}/file.png';
  },

  assetFolderId() {
    return faker.datatype.number({
      min: 100,
      max: 300,
    });
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  video: trait({
    assetTypeSelector() {
      return 'Video';
    },

    afterCreate(asset, server) {
      asset.update({
        assetFormatRelations: [
          server.create('asset-format-relation', 'formatVideo'),
        ],
      });
    },
  }),

  image: trait({
    assetTypeSelector() {
      return 'Image';
    },

    afterCreate(asset, server) {
      asset.update({
        assetFormatRelations: [
          server.create('asset-format-relation', 'source'),
        ],
      });
    },
  }),
});
